import { render, staticRenderFns } from "./ContentSubTitle.vue?vue&type=template&id=2d52c9b5&"
import script from "./ContentSubTitle.vue?vue&type=script&lang=js&"
export * from "./ContentSubTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports